import { Component } from '@angular/core';

import { CustomPageBlockComponent } from './custom-page-block.component';

/**
 * Display a heading with the specified level and content.
 */
@Component({
  selector: 'app-custom-page-heading',
  template: `
    <div class="max-w-screen-lg mx-auto px-8">
      <div
        class="[&>*]:leading-tight [&>*]:font-bold [&>h2]:text-2xl md:[&>h2]:text-4xl [&>h3]:text-xl md:[&>h3]:text-3xl [&>h4]:text-lg md:[&>h4]:text-2xl [&>h5]:text-base md:[&>h5]:text-xl [&>h6]:text-sm md:[&>h6]:text-lg"
        innerHTML="<{{ data().level }}>{{ data().content }}</{{ data().level }}>"
      ></div>
    </div>
  `,
  standalone: true,
})
export class CustomPageHeadingComponent extends CustomPageBlockComponent<'heading'> {}
